// Exposes the in-memory repositories (and their backing store) on `window` when running in
// e2e mode, so Playwright specs can seed data directly through the same repository code the
// app itself uses instead of poking the DOM through dozens of slow, brittle UI interactions.
// Only ever active under REACT_APP_E2E=true — see src/e2eMode.ts.
import { isE2EMode } from "./e2eMode";
import { inMemoryRepositories } from "./repositories/inmemory";
import { store } from "./repositories/inmemory/store";
import { InvoiceStatus } from "./repositories/types";

declare global {
  interface Window {
    __e2eRepositories__?: typeof inMemoryRepositories;
    __e2eStore__?: typeof store;
    __e2eInvoiceStatus__?: typeof InvoiceStatus;
  }
}

if (isE2EMode) {
  window.__e2eRepositories__ = inMemoryRepositories;
  window.__e2eStore__ = store;
  window.__e2eInvoiceStatus__ = InvoiceStatus;
}
